{
  "promoter": {
    "brand": { "name": "CoreWay", "product": "Partners" },
    "common": {
      "signOut": "Cerrar sesión",
      "loading": "Cargando…",
      "retry": "Reintentar",
      "copy": "Copiar",
      "copied": "Copiado",
      "openPdf": "Abrir PDF",
      "language": "Idioma"
    },
    "errors": {
      "programClosed": "El programa de promotores no está abierto ahora mismo. Vuelve más tarde.",
      "noInvitation": "No hay ninguna invitación para este correo. Entra con el correo al que te llegó la invitación.",
      "alreadyClaimed": "Esta invitación ya está vinculada a una cuenta. Entra con esa cuenta.",
      "agreementChanged": "El acuerdo cambió mientras lo leías. Revisa la nueva versión.",
      "consentChanged": "El texto del consentimiento electrónico cambió. Revísalo de nuevo.",
      "consentRequired": "Marca la casilla para aceptar los registros y firmas electrónicos.",
      "signatureRequired": "Dibuja primero tu firma en el recuadro.",
      "signatureTooLarge": "La imagen de la firma es demasiado grande. Bórrala y firma de nuevo.",
      "agreementRequired": "Primero firma el acuerdo de promotor.",
      "w9Required": "Necesitamos un W-9 aceptado antes de poder pagarte.",
      "requestPending": "Ya tienes una solicitud de pago pendiente de revisión.",
      "nothingAvailable": "Todavía no hay nada disponible para pagar.",
      "uploadNotFound": "No encontramos tu archivo. Vuelve a elegirlo.",
      "notPdf": "El W-9 tiene que ser un archivo PDF.",
      "tooLarge": "El archivo tiene que ser un PDF de 10 MB como máximo.",
      "alreadySubmitted": "Este archivo ya se envió.",
      "notAllowed": "Esta cuenta no puede usar el portal de promotores.",
      "network": "No pudimos conectar con Coreway. Revisa tu conexión e inténtalo de nuevo.",
      "generic": "Algo salió mal. Inténtalo de nuevo."
    }
  }
}
